// extracted by mini-css-extract-plugin
export var accordionPanel = "ProductInformation-mps-module--accordionPanel--d1e49";
export var root = "ProductInformation-mps-module--root--bd4ea";
export var tabPanel = "ProductInformation-mps-module--tabPanel--2651c";